import unwrapNodes from "../../helpers/unwrapNodes";
import storefront from "../../global/storefront";
import { storefrontCartAdditionalData } from "../storefront/queries";

export default async function addAdditionalCartData(cartData) {
  const additionalCartData = await storefront
    .request({
      query: storefrontCartAdditionalData,
      variables: {
        id: cartData.id,
      },
    })
    .then(({ data }) => {
      return unwrapNodes(data.cart);
    });

  cartData.items.forEach((item, i) => {
    item.additionalData = additionalCartData.lines[i];
  });

  return cartData;
}
